import { Observable, of } from 'rxjs';

import { Container, Service } from '../../../../symphony';

import { SlCodeBitsContext } from '../../global-constants';
import { SlEventsService } from '../Business/sl-events.service';
import { IActionData } from '../../global-interface';
import { SlTrackingService } from '../Business/sl-tracking.service';
import { SlCodeBitsService } from '../Business/sl-code-bits.service';

@Service()
export class SlActionsController {
	private eventsService = Container.take(SlCodeBitsContext, SlEventsService);

	private codeBitsService = Container.take(
		SlCodeBitsContext,
		SlCodeBitsService,
	);

	private trackingService = Container.take(
		SlCodeBitsContext,
		SlTrackingService,
	);

	// Mount events

	public onHotTodayMountHandler = (): Observable<null> => this.eventsService.onHotTodayMount();

	public onCodeBitsListPageMountHandler = (): Observable<null> => this.eventsService.onCodeBitsListPageMount();

	public onCodeBitsListMountHandler = ({
		orderFilter,
		codeBitsListSearchText,
		currentPageNumber,
		languageFilter,
	}: IActionData): Observable<null> => this.eventsService.onCodeBitsListMount(
		codeBitsListSearchText,
		orderFilter,
		currentPageNumber,
		languageFilter,
	);

	// Click events
	public onProfileButtonClickHandler = ({
		userId,
	}: IActionData): Observable<null> => this.eventsService.onProfileButtonClick(userId);

	public onProjectClickHandler = ({
		codeId,
	}: IActionData): Observable<null> => this.eventsService.onProjectClick(codeId);

	public onTopicClickHandler = ({
		codeId,
	}: IActionData): Observable<null> => this.eventsService.onTopicClick(codeId);

	public onSearchClickHandler = ({
		searchedInputValue,
	}: IActionData): Observable<null> => this.eventsService.onSearchClick(searchedInputValue);

	public onNewCodeClickHandler = (): Observable<null> => this.eventsService.onNewCodeClick();

	public onPaginationClickHandler = ({
		currentPageNumber,
		paginationCtaType,
		clickedPageNumber,
	}: IActionData): Observable<null> => this.eventsService.onPaginationClick(
		currentPageNumber,
		paginationCtaType,
		clickedPageNumber,
	);

	public onEmptyCodeBitsCTAClickHandler = ({
		ctaType,
		pathname,
	}: IActionData): Observable<null> => this.eventsService.onEmptyCodeBitsCTAClick(ctaType, pathname);

	// Business events
	public getHotTodayTopicsHandler = () => this.codeBitsService.getHotTodayProjects();

	public getCodeBitsListHandler = ({
		orderFilter,
		codeBitsListSearchText,
		currentPageNumber,
		languageFilter,
	}: IActionData) => this.codeBitsService.getCodeBitsList(
		codeBitsListSearchText,
		orderFilter,
		currentPageNumber,
		languageFilter,
	);

	public getLanguagesCatalogHandler = () => this.codeBitsService.getLanguagesCatalog();

	public orderFilterChangeHandler = ({
		selectedOrderFilter,
		selectedLanguageFilter,
	}: IActionData) => this.eventsService.orderFilterChange(
		selectedOrderFilter,
		selectedLanguageFilter,
	);

	public languageFilterChangeHandler = ({
		selectedLanguageFilter,
		selectedOrderFilter,
	}: IActionData) => this.eventsService.languageFilterChange(
		selectedLanguageFilter,
		selectedOrderFilter,
	);

	// Tracking
	public onTrackActionHandler = ({
		trackData,
	}: IActionData): Observable<null> => {
		this.trackingService[trackData.actionName](trackData);
		return of(null);
	};
}
